import { isUndefined } from 'lodash/lang';

const defaultState = {
  parameters: {
    jobTitle: '',
    jobLocation: '',
    employmentType: 'all',
    previousAgencies: '',
    enquiry: '',
    jobSpecification: undefined,
    companyName: '',
    email: '',
    contactName: '',
    phoneNumber: '',
  },
  submitting: false,
  errors: {},
  success: false,
};
const mutations = {
  setParameter(state, { key, value }) {
    state.parameters[key] = value;
    if (state.errors[key]) {
      delete state.errors[key];
    }
  },
  setSubmitting(state, submitting = true) {
    state.submitting = submitting;
  },
  resetState(state) {
    state = {
      ...defaultState,
    };
  },
  setErrors(state, errors) {
    state.errors = errors;
  },
  setSuccess(state, success = true) {
    state.success = success;
  },
};
const actions = {
  async submitEmployerDetailsForm({ state, commit }) {
    if (state.submitting) {
      return;
    }
    commit('setSubmitting');

    const body = new FormData();
    body.append('jobTitle', state.parameters.jobTitle);
    body.append('jobLocation', state.parameters.jobLocation);
    body.append('employmentType', state.parameters.employmentType);
    body.append('previousAgencies', state.parameters.previousAgencies);
    body.append('enquiry', state.parameters.enquiry);
    body.append('companyName', state.parameters.companyName);
    body.append('email', state.parameters.email);
    body.append('contactName', state.parameters.contactName);
    body.append('phoneNumber', state.parameters.phoneNumber);
    if (!isUndefined(state.parameters.jobSpecification)) {
      body.append('jobSpecification', state.parameters.jobSpecification);
    }

    const response = await fetch('/api/employerDetailsSubmit', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        Accept: 'application/json',
      },
      body,
    });

    if (!response.ok) {
      commit('setSuccess', false);
      if (response.status === 422) {
        // Laravel Validation Errors
        const responseErrors = (await response.json()).errors ?? {};
        commit('setErrors', responseErrors);
      } else {
        // Other Errors
        commit('setErrors', {
          error: ['An error has occurred, please try again later.'],
        });
      }
    } else {
      commit('setSuccess');
      commit('setErrors', {});
    }
    commit('setSubmitting', false);
  },
};
export default {
  namespaced: true,
  actions,
  mutations,
  state: defaultState,
};
